import React, { Component } from "react";
import { MdClose } from "react-icons/md";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import SimpleLabel from "../../base/features/micro/SimpleLabel";
import { apiService } from "../../base/utils/service";
import { address, creat_address, updateAddress } from "./services";

class AddressDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userLocation:
        this.props.location.state && this.props.location.state.userLocation,
      address: "",
      postalCode: "",
      phone: "",
      pending: false,
      uid: window.location.pathname.split("/")[2],
    };
  }
  componentDidMount() {
    if (this.state.uid !== "add") {
      this.getAddressDetail();
    }
    if (this.props.location.state && this.props.location.state.address) {
      this.setState({ pending: true });
      address(this.state.uid).then((items) => {
        if (items) {
          if (!this.state.userLocation) {
            this.setState({
              userLocation: {
                latitude: items.latitude,
                longitude: items.longitude,
              },
            });
          }
          this.setState({
            address: items.address,
            phone: items.phone,
            postalCode: items.postcode,
            pending: false,
          });
        }
      });
    }
  }
  getAddressDetail() {
    apiService(`v1/contents/addresses/${this.state.uid}`).then((data) => {
      if (data) {
        this.setState({
          address: data.address,
          phone: data.phone,
          postalCode: data.postcode,
          userLocation: { latitude: data.latitude, longitude: data.longitude },
        });
      }
    });
  }
  submitNewAddress() {
    let params = {
      phone: this.state.phone,
      address: this.state.address,
      postcode: this.state.postalCode,
      latitude: this.state.userLocation.latitude,
      longitude: this.state.userLocation.longitude,
    };
    if (this.check_params(params)) {
      this.setState({ pending: true });
      creat_address(params).then((items) => {
        if (this.props.location.state.fromCartOrder) {
          window.history.go(-2);
        } else {
          window.location.href = "/addresses";
        }
        this.setState({ pending: false });
      });
    }
  }
  update_address() {
    let params = {
      phone: this.state.phone,
      address: this.state.address,
      postcode: this.state.postalCode,
      latitude: this.state.userLocation.latitude,
      longitude: this.state.userLocation.longitude,
    };
    if (this.check_params(params)) {
      this.setState({ pending: true });
      updateAddress(this.state.uid, params).then((items) => {
        if (items) {
          window.location.href = "/addresses";
          this.setState({ pending: false });
        }
      });
    }
  }
  check_params(params) {
    if (!this.state.userLocation) {
      Swal.fire({
        icon: "info",
        text: "آدرس را از نقشه انتخاب کنید",
        timer: 3000,
        confirmButtonText: "تایید",
      });
      return false;
    }
    if (params.postcode.length !== 10) {
      Swal.fire({
        icon: "info",
        text: "کد پستی باید 10 رقم باشد",
        timer: 3000,
        confirmButtonText: "تایید",
      });
      return false;
    }
    if (params.phone.length > 0 && params.phone.length !== 11) {
      Swal.fire({
        icon: "info",
        text: "شماره همراه باید 11 رقم باشد",
        timer: 3000,
        confirmButtonText: "تایید",
      });
      return false;
    }
    if (params.phone.length > 0 && !params.phone.startsWith("09")) {
      Swal.fire({
        icon: "info",
        text: "شماره صحیح وارد کنید",
        timer: 3000,
        confirmButtonText: "تایید",
      });
      return false;
    }
    return true;
  }
  render() {
    return (
      <div className="container-fluid px-0">
        <header
          className="row mx-0 px-4 py-2-3 position-fixed bg-white"
          style={{ top: "0", right: "0", left: "0" }}
        >
          <div className="col align-self-center px-0">
            <h1 className="fs-5 fw-bolder mb-0">
              {this.state.uid !== "add" ? "ویرایش آدرس" : "آدرس جدید"}
            </h1>
          </div>
          <div className="col-auto align-self-center px-0">
            <MdClose
              size="26"
              className=""
              onClick={() =>
                this.props.location.state &&
                this.props.location.state.fromCartOrder
                  ? window.history.go(-2)
                  : (window.location.href = "/addresses")
              }
            />
          </div>
        </header>
        <body style={{ marginTop: "70px", marginBottom: "90px" }}>
          <div className="row mx-0 px-4">
            <div className="col px-0 fs-6 align-self-center">
              آدرس هایی که برای دریافت سفارشات خود نیاز دارید را اینجا وارد
              کنید.
            </div>
          </div>
          <div className="row mx-4 p-3 border mt-4 rounded14">
            <div className="col px-0 fw-bolder">
              <p>انتخاب آدرس از روی نقشه</p>
              <Link
                to={{
                  pathname: "/map",
                  state: {
                    userLocation: this.state.userLocation,
                    uid: this.state.uid,
                  },
                }}
              >
                <button className="btn rounded14 fw-bolder color-main border">
                  نمایش نقشه
                </button>
              </Link>
            </div>
            <div className="col-auto px-0">
              <img
                src={require("./icons/world_pin.svg").default}
                alt="world_pin"
                width="50"
              />
            </div>
          </div>
          <div className="row mx-4 mt-4">
            <div className="col-12 px-0 position-relative">
              <textarea
                rows="4"
                className="rounded14 border p-3 w-100"
                placeholder="آدرس پستی*"
                value={this.state.address}
                onChange={(e) => this.setState({ address: e.target.value })}
              />
              {this.state.address && <SimpleLabel text="آدرس پستی*" />}
            </div>
            <div className="col-12 mt-3 px-0 position-relative">
              <input
                type="tel"
                className="rounded14 border p-3 w-100"
                placeholder="کد پستی*"
                maxLength="10"
                value={this.state.postalCode}
                onChange={(e) => this.setState({ postalCode: e.target.value })}
              />
              {this.state.postalCode && <SimpleLabel text="کد پستی*" />}
            </div>
            <div className="col-12 mt-3 px-0 position-relative">
              <input
                type="tel"
                maxLength="11"
                className="rounded14 border p-3 w-100"
                placeholder="تلفن همراه (اختیاری)"
                value={this.state.phone}
                onChange={(e) => this.setState({ phone: e.target.value })}
              />
              {this.state.phone && <SimpleLabel text="تلفن همراه (اختیاری)" />}
            </div>
          </div>
        </body>
        <footer
          className="row mx-0 px-4 py-2-3 position-fixed bg-white shadow-sm"
          style={{ bottom: "0", right: "0", left: "0" }}
        >
          <button
            onClick={() => {
              this.state.uid !== "add"
                ? this.update_address()
                : this.submitNewAddress();
            }}
            disabled={
              !this.state.address ||
              !this.state.postalCode ||
              !this.state.userLocation
            }
            className="w-100 rounded28 bg-color-main text-white btn py-2-3"
          >
            {this.state.pending ? (
              <span className="spinner-border spinner-border-sm text-white align-middle"></span>
            ) : (
              "ذخیره"
            )}
          </button>
        </footer>
      </div>
    );
  }
}

export default AddressDetail;
